import React from 'react';
import { Link } from 'gatsby';
import styled from '../styled';

const NavWrapper = styled('div')`
  position: relative;
  opacity: 0.8;
  z-index: 2;
  max-width: 1120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(p) => p.theme.spacing(8)}px;
  margin-top: ${(p) => p.theme.spacing(8)}px;

  @media (max-width: 800px) {
    margin: ${(p) => p.theme.spacing(1)}px auto ${(p) => p.theme.spacing(3)}px;
    display: block;
  }
`;

const Branding = styled<typeof Link, { mode: string }>(Link)`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 2px;
  color: ${(p) =>
    p.mode === 'light' ? p.theme.palette.grey[900] : p.theme.palette.grey[100]};

  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const Label = styled('div')`
  border-radius: ${(p) => p.theme.shape.borderRadius}px;
  background-color: ${(p) => p.theme.palette.grey[100]};
  color: ${(p) => p.theme.palette.grey[800]};
  padding: 4px 8px;
  margin-left: ${(p) => p.theme.spacing(1)}px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0;
`;

const LinkContainer = styled<'div', { mode: string }>('div')`
  a {
    color: ${(p) =>
      p.mode === 'light'
        ? p.theme.palette.grey[900]
        : p.theme.palette.grey[100]};
    display: inline-block;
    margin-left: 24px;
  }

  @media (max-width: 800px) {
    text-align: center;

    a {
      margin: ${(p) => p.theme.spacing(1)}px ${(p) => p.theme.spacing(1)}px 0 0;
    }
  }
`;

const Button = styled(Link)`
  background: linear-gradient(86.61deg, #f4faff 23.95%, #e5ebf1 97.88%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: ${(p) => p.theme.palette.grey[800]} !important;
  font-weight: 600;
  padding: 12px 24px;

  &:hover {
    color: ${(p) => p.theme.palette.grey[800]};
    background: linear-gradient(86.61deg, #f4faff 23.95%, #e5ebf1 97.88%);
    box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.2);
  }
`;

export const TrendsNav = ({
  to,
  mode,
  hideLinks = false
}: {
  to: string;
  mode: 'light' | 'dark';
  hideLinks?: boolean;
}) => {
  return (
    <NavWrapper>
      <Branding to={to} mode={mode}>
        Blogging for Devs <Label>Trends</Label>
      </Branding>
      {!hideLinks && (
        <LinkContainer mode={mode}>
          It's free:
          <Button to="/">Blogging for Devs Course</Button>
        </LinkContainer>
      )}
    </NavWrapper>
  );
};
